import { StatusBadgeHelp } from "@dehub/theme"
import { DotPill, type Tone } from "../delivery/atoms"
import { effectiveOrderStatus, orderStatusUi } from "../../utils/order-status-ui"

/** Order status → dot colour (canvas OrdB_*: ok = green, in progress = amber, stopped = red). */
const STATUS_TONE: Record<string, Tone> = {
  DRAFT: "grey",
  REGISTERED: "blue",
  REVIEWED: "amber",
  APPROVED: "green",
  AUTHORIZED: "green",
  PREPARING: "amber",
  DELIVERING: "amber",
  DELIVERED: "green",
  CLOSED: "green",
  REVIEW_REJECTED: "red",
  CANCELED: "red",
  AUTO_CANCELED: "red",
  REJECTED: "red",
}

export const orderStatusTone = (status?: string | null): Tone => STATUS_TONE[String(status ?? "").toUpperCase()] ?? "grey"

/**
 * Buyer-side order status as a DotPill. The status is the effective one (a confirmed
 * order whose delivery note is moving reads «Бэлтгэж буй» / «Хүргэж буй» / «Хүргэгдсэн»).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function OrderStatusPill({ order, help }: Readonly<{ order: any; help?: boolean }>) {
  const status = effectiveOrderStatus(order)
  const label = orderStatusUi(status).label
  const pill = <DotPill tone={orderStatusTone(status)}>{label}</DotPill>
  // @dehub/help: hover popover from `order.status` (buyer rows by role/side context, R5).
  return help ? <StatusBadgeHelp helpNs="order.status" code={status} name={label}>{pill}</StatusBadgeHelp> : pill
}
